import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const UploadImagesModal = ({ setAttachments, onHide, ...props }) => {
  const [files, setFiles] = useState([]);

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const imageFiles = selectedFiles.filter(file =>
      file.type.startsWith("image/")
    );
    setFiles((prev) => [...prev, ...imageFiles]);
  };

  // Handle delete
  const handleDelete = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  //uploading attachments
  const uploadAttachments = () => {
    setAttachments((attachments) => [...attachments, ...files]);
    setFiles([]);
    closeModel();
  }

  const closeModel = () => {
    onHide();
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="upload-file-modal"
    >
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center border-bottom pb-3">
          <h4 className="font-14 font-weight-bold heading-color mb-0">
            Upload Images
          </h4>
          <button className="bg-transparent border-0" onClick={closeModel}>
            <img src="/assets/images/cross-icon.svg" alt="Close" />
          </button>
        </div>

        {/* File Upload Trigger */}
        <div className="w-100 pt-2">
          <label htmlFor="myfile" className="file-upload-wrapper">
            <img src="/assets/images/upload-icon.svg" alt="Upload" />
            <p className="font-13 font-weight-medium text-color">
              Drag & drop or{" "}
              <span className="font-13 font-weight-medium text-decoration-underline text-success">
                browse
              </span>
            </p>
          </label>
          <input
            type="file"
            id="myfile"
            name="myfile"
            multiple
            onChange={handleFileChange}
            accept="image/*"
            style={{ display: "none" }}
          />
        </div>

        {/* Display Selected Files */}
        <div className="py-2">
          {files.map((file, index) => (
            <div className="upload-file-card mb-2" key={index}>
              <div className="upload-file-info">
                <div className="d-flex gap-3">
                  <img
                    src={URL.createObjectURL(file)}
                    className="file-icon"
                    alt="Preview"
                    style={{ width: "30px", height: "30px", objectFit: "cover" }}
                  />
                  <div className="file-name">
                    <h6>{file.name}</h6>
                    <p>{file.type.split("/")[1].toUpperCase()} • {file.size} bytes</p>
                  </div>
                </div>
                <button
                  className="border-0 bg-transparent"
                  onClick={() => handleDelete(index)}
                >
                  <img src="/assets/images/delete-icon.svg" alt="Delete" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="d-flex justify-content-center gap-4">
          <button className="n-u-btn" onClick={() => uploadAttachments()}>
            Upload
          </button>
          <button className="c-b-btn" onClick={closeModel}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadImagesModal;
